export default "__VITE_ASSET__poF3A1pn__"